import * as theme from '../../theme';
import Heading from '../../components/Heading';
import { useNavigate } from "react-router";
import { whatsNewList } from '../../contexts/WhatsNewContext';
import dayjs from 'dayjs';

export default function WhatsNew() {
  const navigate = useNavigate();

  function navigateBack() {
    navigate(`/dashboard`);
  }

  return (
    <div style={{ ...theme.Container.flexColumn.flexColumnContainer, ...theme.Container.center800 }}>
      <div style={theme.Container.flexColumn}>
        <Heading
          title={`What's New`}
          onClick={() => navigateBack()}
        />
        <div style={{ ...theme.SubText2, paddingLeft: 10, paddingRight: 10 }}>
          Running list of updates to the TruBalance App
        </div>
      </div>
      <div style={theme.Container.fullMax}>
        <div style={theme.Container.flexOne}>
          {whatsNewList.map((whatsNew, index) => (
            <div key={index} style={{ padding: '0px 10px' }}>
              <div style={{ fontWeight: 600, fontSize: 16, paddingBottom: 6 }}>{dayjs(whatsNew.date, 'MM-DD-YYYY').format('MMMM D, YYYY')}</div>
              <ul style={{ marginTop: 5, fontSize: 14, paddingBottom: 15, borderBottom: '1px solid #ccc', listStyleType: 'disc', paddingLeft: 20, marginBottom: 20 }}>
                {whatsNew.items.map((item, itemIndex) => (
                  <li key={itemIndex} style={{ paddingBottom: 8 }}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}